import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

const Machine = () => {
  const { t } = useTranslation();
  return <Outlet />;
};

export default Machine;
